import { GuardId, useGuardLoadingState } from '@ekhodealer/ekho-common/components';

import type { ReactNode } from 'react';

import { useGetUserServicesProviders } from '@common/hooks/useGetUserServicesProviders';

interface SessionDataGuardProps {
	children: ReactNode;
}

/**
 * SessionDataGuard
 * Keeps the global LoadingPage visible until service-provider data has been
 * fetched. Without this guard, the loading screen dismisses as soon as auth
 * completes, causing the accounts dropdown to briefly show raw SP IDs instead
 * of names while the batch request is in flight.
 *
 * Must be placed inside PortalAccessGuard (needs authenticated user with /me)
 * and outside AppLayout (so the loading page covers the entire shell).
 */
export function SessionDataGuard({ children }: SessionDataGuardProps) {
	const { isLoading } = useGetUserServicesProviders();

	useGuardLoadingState(GuardId.SESSION_DATA, isLoading);

	if (isLoading) return null;

	return <>{children}</>;
}
